export default {
  common: {
    loadFailed: "불러오지 못했습니다. 다시 시도하세요.",
    saveFailed: "저장하지 못했습니다. 다시 시도하세요.",
    refresh: '새로고침', search: '조회', cancel: '취소', save: '저장', edit: '편집', delete: '삭제', disable: '비활성화', view: '보기',
    share: '공유', shared: '공유됨', revoke: '해제', authorize: '권한 부여', actions: '작업', all: '전체', readOnly: '읽기 전용', collaboration: '협업',
    normal: '정상', disabled: '비활성', enabled: '사용', closed: '사용 안 함', noData: '데이터 없음', notFilled: '미입력', unassigned: '미할당',
    unknownOrganization: '알 수 없는 조직', selectOrganization: '조직 선택', includeChildren: '하위 조직 포함', description: '설명', remarks: '비고',
    organization: '조직', owningOrganization: '소속 조직', loginName: '로그인명', nickname: '닉네임', phone: '전화번호', role: '역할', status: '상태',
    permission: '권한', validThrough: '유효 기간', device: '장비', deviceName: '장비명', chipId: '칩 ID', deviceType: '장비 유형', hardwareVersion: '하드웨어 버전', softwareVersion: '소프트웨어 버전', type: '유형', owner: '소유자',
    deviceKeywordPlaceholder: '장비명, 설명 또는 칩 ID', selectUser: '사용자를 선택하세요', saveSuccess: '저장되었습니다', authorizationSuccess: '권한이 부여되었습니다',
    operationConfirm: '작업 확인', revoked: '해제되었습니다'
  },
  theme: {
    exactPhone: '전체 전화번호를 입력하세요. 해외 번호는 국가번호를 포함하세요 (다른 조직 검색 가능)',
    title: '조직 테마', keywordPlaceholder: '테마명, 설명 또는 FourCC', themeName: '테마명', editTitle: '테마 메타데이터 편집',
    shareTitle: '테마 공유', selectOrgUser: '테마 소속 조직의 사용자 선택', confirmRevoke: '이 테마 관계를 해제하시겠습니까?'
  },
  management: {
    title: '조직 관리', peopleManagement: '구성원 관리', visibleOrganizations: '조회 가능한 조직', currentOrganization: '현재 조직', addChild: '하위 조직 추가',
    organizationCode: '조직 코드', level: '레벨', path: '경로', childOrganizations: '하위 조직', dragToSort: '행을 끌어 같은 레벨의 순서를 조정하세요',
    saveOrder: '순서 저장', dragSort: '끌어서 정렬', noChildren: '하위 조직 없음', selectLeftOrganization: '왼쪽에서 조직을 선택하세요',
    editTitle: '조직 편집', createTitle: '조직 추가', organizationName: '조직명', parentOrganization: '상위 조직', autoGenerated: '시스템 자동 생성',
    enterOrganizationName: '조직명을 입력하세요', deleteConfirmMessage: '삭제 전에 조직에 사용자, 장비, 테마가 없는지 확인하세요.',
    deleteConfirmTitle: '삭제 확인', deleteSuccess: '삭제되었습니다', orderSaved: '순서가 저장되었습니다',
    moveParent: '상위 조직 변경', moveTitle: '조직 상위 변경', moveSource: '대상 조직', moveTarget: '새 상위 조직',
    moveTargetPlaceholder: '조직 이름으로 필터링', selectedTarget: '선택한 상위 조직', moveReason: '사유', moveReasonPlaceholder: '선택 사항',
    previewImpact: '영향 미리보기', confirmMove: '변경 확인', moveBlocked: '이 변경은 실행할 수 없습니다', moveSummary: '영향 미리보기',
    currentPath: '현재 경로', newPath: '변경 후 경로', nodes: '조직 수', users: '사용자 수', boards: '장치 수', themes: '테마 수',
    affectedSubadmins: '영향받는 하위 관리자', selectMoveTarget: '새 상위 조직을 선택하세요',
    moveConfirmMessage: '이 조직과 모든 하위 조직을 새 상위 조직으로 이동하시겠습니까? 사용자, 장치, 테마 소속과 개별 권한은 변경되지 않습니다.',
    moveSuccess: '조직 상위를 변경했습니다'
  },
  users: {
    title: '조직 구성원', addUser: '구성원 추가', organizationScope: '조직 범위', keywordPlaceholder: '로그인명, 닉네임 또는 전화번호', accountStatus: '계정 상태',
    changeOrganization: '조직 변경', resetPassword: '비밀번호 재설정', editTitle: '구성원 편집', createTitle: '구성원 추가', password: '비밀번호',
    keepPasswordPlaceholder: '변경하지 않으려면 비워 두세요', passwordPlaceholder: '비밀번호 입력', confirmPassword: '비밀번호 확인', selectRole: '역할 선택',
    dataScope: '데이터 범위', moveTitle: '구성원 조직 변경', person: '구성원', targetOrganization: '대상 조직', detailsTitle: '구성원 상세',
    scopeCalculatedByServer: '서버에서 역할에 따라 계산', selectTargetOrganization: '대상 조직을 선택하세요', organizationChanged: '조직이 변경되었습니다',
    completeUserInfo: '필수 구성원 정보를 모두 입력하세요', saveFailed: '구성원 저장에 실패했습니다', passwordMismatch: '비밀번호가 일치하지 않습니다', enterNewPassword: '새 비밀번호를 입력하세요',
    passwordMinLength: '비밀번호는 6자 이상이어야 합니다', passwordResetSuccess: '비밀번호가 재설정되었습니다',
    disableConfirm: '비활성화하면 이 계정은 로그인할 수 없습니다. 계속하시겠습니까?', accountDisabled: '계정이 비활성화되었습니다'
  },
  roles: {
    title: '역할 및 권한', builtinRoles: '기본 역할', code: '코드', permissionPoints: '권한 항목', group: '그룹', permissionCode: '권한 코드',
    name: '이름', roleHasPermission: '역할 보유', description: '설명'
  },
  myBoards: {
    title: '내 메인보드', owned: '소유', relationship: '관계', capability: '기능', operable: '작업 가능', noValidRelations: '유효한 장비 관계가 없습니다', renameTitle: '메인보드 이름 변경', nameRequired: '메인보드 이름을 입력하세요', renamed: '메인보드 이름이 변경되었습니다'
  },
  orgBoards: {
    internalUsers: "조직 내 사용자",
    externalUsers: "외부 협업자",
    source: "권한 출처",
    legacySource: "기존 관계",
    permanent: "만료 없음",
    expired: "만료됨",
    editAuthorization: "장비 권한 편집",
    exactPhone: "국가 코드를 포함한 전화번호 (예: +82)",
    futureExpiry: "유효 기간은 현재 시간 이후여야 합니다",
    confirmExternal: "{user}에게 \"{board}\" 권한을 부여하시겠습니까? 권한: {permission}, 만료: {expiry}. 기존 권한은 갱신됩니다.",
    title: '조직 장비', multipleOwners: '소유자 여러 명', ownerUnavailable: '소유자 사용 불가', managementCapability: '관리 기능', userRelations: '사용자 관계',
    organizationAssignment: '소속 조직', manageRelations: '관계 관리', transferOwner: '소유자 이전', relationsTitle: '장비 사용자 관계',
    selectOrganizationUser: '조직 내 사용자 선택', transferOwnerTitle: '장비 소유자 이전', newOwner: '새 소유자',
    selectDeviceOrgUser: '장비 소속 조직의 사용자 선택', confirmTransfer: '이전 확인', changeDeviceOrganization: '장비 조직 변경',
    confirmRevoke: '이 장비 관계를 해제하시겠습니까?', assignOrganizationFirst: '먼저 장비의 소속 조직을 지정하세요', selectNewOwner: '새 소유자를 선택하세요',
    ownerUpdated: '소유자가 변경되었습니다', organizationUpdated: '조직이 변경되었습니다', renameTitle: '메인보드 이름 변경', nameRequired: '메인보드 이름을 입력하세요', renamed: '메인보드 이름이 변경되었습니다'
  },
  platformBoards: {
    title: '플랫폼 장비 운영', addDevice: '장비 추가', taskLimit: '작업 한도', sessionLimit: '회차 한도', usedSessions: '사용 회차', bootCount: '부팅 횟수',
    autoUpgrade: '자동 업그레이드', platformValidity: '플랫폼 유효 기간', lastOnline: '마지막 온라인', assignOwner: '소유자 지정', reboot: '재부팅', refurbish: '초기화',
    editTitle: '플랫폼 장비 편집', createTitle: '플랫폼 장비 추가', deviceDescription: '장비 설명', maxTasks: '최대 작업 수',
    longTermPlaceholder: '비워 두면 만료되지 않음', enterChipId: '칩 ID를 입력하세요', enterDeviceName: '장비명을 입력하세요', deviceUpdated: '장비가 변경되었습니다',
    deviceCreated: '장비가 생성되었습니다', enterTargetUserUid: '대상 사용자 UID를 입력하세요', assignOwnerTitle: '장비 소유자 지정',
    targetUserUidRequired: '대상 사용자 UID는 필수입니다', rebootConfirm: '이 장비를 재부팅하시겠습니까?', rebootSent: '재부팅 명령을 전송했습니다',
    refurbishConfirm: '초기화하면 장비 관계, 테마 스냅샷 및 실행 기록이 삭제됩니다. 계속하시겠습니까?', highRiskOperation: '위험 작업',
    deviceRefurbished: '장비가 초기화되었습니다', deleteConfirm: '삭제하면 장비 관계, 테마 스냅샷 및 실행 기록이 삭제됩니다. 계속하시겠습니까?',
    deviceDeleted: '장비가 삭제되었습니다',
    manageCapabilities: '메인보드 기능 권한',
    capabilityDescription: '실행 가능 기한 조회와 관리자 매개변수 변경만 허용합니다. 소유자 또는 협업 관계는 변경하지 않습니다.',
    capabilityUser: '권한 사용자',
    capabilityType: '기능 유형',
    boardAdminParamsCapability: '관리자 매개변수',
    capabilityGranted: '기능 권한을 부여했습니다',
    revokeCapabilityConfirm: '이 사용자의 관리자 매개변수 권한을 해제하시겠습니까?'
  },
  deviceTypes: { controlV5: '메인 컨트롤러 V5', controlV3: '메인 컨트롤러 V3', SNA: 'SNA', SNIO: 'SNIO', SNU: 'SNU', phone: '전화' },
  roleNames: {
    sivaadmin: '시스템 관리자', admin: '시스템 관리자', subadmin: '하위 관리자', koradmin: '하위 관리자', store_manager: '매장 관리자',
    employee: '직원', platform_staff: '플랫폼 운영 담당자'
  },
  dataScopes: { ALL: '모든 조직', ORG_AND_CHILDREN: '현재 조직 및 하위 조직', SELF_ORG: '현재 조직' },
  permissionGroups: { org: '조직', user: '구성원', board: '장비', platform: '플랫폼', theme: '테마', role: '역할' },
  permissionNames: {
    org_view: '조직 보기', org_create: '조직 추가', org_update: '조직 편집', org_delete: '조직 삭제', org_sort: '조직 정렬', org_move: '조직 상위 변경',
    user_view: '구성원 보기', user_create: '구성원 추가', user_update: '구성원 편집', user_delete: '구성원 삭제', user_disable: '구성원 비활성화',
    user_password_reset: '비밀번호 재설정', user_role_set: '구성원 역할 설정', user_org_move: '구성원 조직 변경',
    board_own_view: '내 장비 보기', board_org_view: '조직 장비 보기', board_org_set: '장비 조직 설정', board_user_set: '장비 사용자 설정',
    board_external_share_set: '장비 외부 공유', board_owner_transfer: '장비 소유자 이전', board_capability_set: '메인보드 기능 권한 설정', platform_board_ops: '플랫폼 장비 운영',
    theme_view: '테마 보기', theme_org_view: '조직 테마 보기', theme_edit: '테마 편집', theme_user_set: '테마 사용자 설정',
    role_view: '역할 보기', role_create: '역할 추가', role_update: '역할 편집', role_delete: '역할 삭제', permission_view: '권한 보기'
  },
  permissionDescriptions: {
    org_view: '조직 트리 보기', org_create: '조직 추가', org_update: '조직 정보 변경', org_delete: '사용되지 않는 조직 삭제', org_sort: '같은 레벨의 조직 순서 변경', org_move: '조직을 이동하고 하위 경로를 갱신',
    user_view: '조직 범위 내 구성원 보기', user_create: '조직 범위 내 구성원 추가', user_update: '조직 범위 내 구성원 변경',
    user_delete: '조직 범위 내 구성원 삭제 또는 비활성화', user_disable: '구성원 로그인 차단', user_password_reset: '구성원 비밀번호 재설정',
    user_role_set: '구성원 역할 할당', user_org_move: '구성원의 소속 조직 변경', board_own_view: '소유 및 공유 장비 보기',
    board_org_view: '조직 범위별 장비 보기', board_org_set: '장비 소속 조직 설정', board_user_set: '장비 사용자 관계 설정',
    board_external_share_set: '정확한 전화번호로 장비 공유', board_owner_transfer: '장비 소유권 이전', board_capability_set: '독립 메인보드 기능 권한 부여 또는 해제', platform_board_ops: '플랫폼 수준 장비 운영 수행',
    theme_view: '사용자 관계에 따라 테마 보기', theme_org_view: '조직 범위별 테마 보기', theme_edit: '관계와 권한에 따라 테마 편집',
    theme_user_set: '테마 사용자 관계 설정', role_view: '역할 보기', role_create: '사용자 지정 역할 추가', role_update: '사용자 지정 역할 편집',
    role_delete: '사용자 지정 역할 삭제', permission_view: '권한 사전 보기'
  }
}
